import { Navigate } from "react-router-dom";

import { DetailsQuestion } from "pages/details-question";
import { LoginPage } from "pages/login";
import QuestionsPage from "pages/questions";

import { AuthGuard, Layout } from "components";

const routes = [
  {
    element: <Layout />,
    children: [
      {
        path: "/questions",
        element: (
          <AuthGuard>
            <QuestionsPage />
          </AuthGuard>
        ),
      },
      {
        path: "/questions/:questionid",
        element: (
          <AuthGuard>
            <DetailsQuestion />
          </AuthGuard>
        ),
      },
    ],
  },
  { path: "/login", element: <LoginPage /> },
  { path: "*", element: <Navigate to="/questions" /> },
];

export default routes;
